import { RequestProps } from "../../../config/InterfacesAndTypes";
import Message from "../../../config/Message";
import { validations } from "../../../config/validations/validations";

export const LoginRequest: any = {
  email: (field?: string) => [
    validations.required.text(field),
    { type: "email", message: Message().email(field) },
  ],
  password: (field?: string) => [validations.required.text(field)],
  confirmPassword: (field?: string) => [
    validations.required.text(field),
    ({ getFieldValue }:any) => ({
      validator(rule:any, value:any) {
        if (!value || getFieldValue("password") === value) {
          return Promise.resolve();
        }
        return Promise.reject(
          "New Password and Confirm Password does not match."
        );
      },
    }),
  ],
}

